/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowStartSoakDto
 */
export interface WorkflowStartSoakDto {
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    attempts?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    admitted?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    admissionRejected?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    elapsedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    maxRunningPerShard?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowStartSoakDto
     */
    shardCount?: number;
}

/**
 * Check if a given object implements the WorkflowStartSoakDto interface.
 */
export function instanceOfWorkflowStartSoakDto(value: object): value is WorkflowStartSoakDto {
    return true;
}

export function WorkflowStartSoakDtoFromJSON(json: any): WorkflowStartSoakDto {
    return WorkflowStartSoakDtoFromJSONTyped(json, false);
}

export function WorkflowStartSoakDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStartSoakDto {
    if (json == null) {
        return json;
    }
    return {
        
        'attempts': json['attempts'] == null ? undefined : json['attempts'],
        'admitted': json['admitted'] == null ? undefined : json['admitted'],
        'admissionRejected': json['admissionRejected'] == null ? undefined : json['admissionRejected'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'maxRunningPerShard': json['maxRunningPerShard'] == null ? undefined : json['maxRunningPerShard'],
        'shardCount': json['shardCount'] == null ? undefined : json['shardCount'],
    };
}

export function WorkflowStartSoakDtoToJSON(json: any): WorkflowStartSoakDto {
    return WorkflowStartSoakDtoToJSONTyped(json, false);
}

export function WorkflowStartSoakDtoToJSONTyped(value?: WorkflowStartSoakDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attempts': value['attempts'],
        'admitted': value['admitted'],
        'admissionRejected': value['admissionRejected'],
        'elapsedMs': value['elapsedMs'],
        'maxRunningPerShard': value['maxRunningPerShard'],
        'shardCount': value['shardCount'],
    };
}

